export const statuses = [
  'Process Started',
  'Audio files downloaded',
  'Session created in db',
  'Session submitted for scoring',
  'Completed',
  'Incomplete'
];
